'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _button = require('./global_components/button.js');

var _button2 = _interopRequireDefault(_button);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactWaypoint = require('react-waypoint');

var _reactWaypoint2 = _interopRequireDefault(_reactWaypoint);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _string_utility = require('../../../packages/common-utilities/src/string_utility.js');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _tracking_utility = require('common-utilities/src/tracking_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChartContainer = function (_React$Component) {
  _inherits(ChartContainer, _React$Component);

  function ChartContainer() {
    _classCallCheck(this, ChartContainer);

    return _possibleConstructorReturn(this, (ChartContainer.__proto__ || Object.getPrototypeOf(ChartContainer)).apply(this, arguments));
  }

  _createClass(ChartContainer, [{
    key: 'getLegends',
    value: function getLegends(createLegendCircle) {
      var legendList = [];
      this.props.legend.map(function (item) {
        return legendList.push(_react2.default.createElement(
          'div',
          { className: 'tag chart-legend' },
          createLegendCircle(item.color),
          _react2.default.createElement(
            'span',
            { className: 'font-regular', 'data-testid': 'chart-legend-' + _string_utility2.default.customKebabCase(item.label) },
            _string_utility2.default.renderFormattedLabel(item.label, item.translationKey)
          )
        ));
      });
      return legendList;
    }
  }, {
    key: 'renderLegend',
    value: function renderLegend() {
      var createLegendCircle = function createLegendCircle(backgroundColor) {
        return _react2.default.createElement('div', { className: 'display-inline-block', style: {
            width: "20px",
            height: "20px",
            backgroundColor: backgroundColor,
            marginRight: "15px",
            verticalAlign: "bottom",
            borderRadius: "25px"
          } });
      };
      if (!(0, _functional_utility.isNilOrEmpty)(this.props.legend)) {
        return _react2.default.createElement(
          'div',
          { className: 'margin-bottom-40', 'data-testid': 'chart-legend' },
          this.getLegends(createLegendCircle)
        );
      }
    }
  }, {
    key: 'trackChartDownload',
    value: function trackChartDownload(key) {
      var trackingObject = {
        "eventCategory": "pdp",
        "eventAction": _tracking_utility.TrackingUtility.getEventAction(key),
        "eventLabel": "download chart data"
      };
      _tracking_utility.TrackingUtility.trackEvent(trackingObject);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var disableButton = this.props.disableButton;


      var excelServiceURL = encodeURI(this.props.gaiaRedirectUrl + '/excel?type=' + this.props.type + '&cusip=' + this.props.cusip + '&country=' + this.props.country + '&role=' + this.props.role + '&locale=' + _string_utility2.default.generateLocale());
      var headerTitle = (0, _functional_utility.isNilOrEmpty)(this.props.chartHeader.key) ? this.props.chartHeader : _string_utility2.default.getLocalizedString(this.props.intl, this.props.chartHeader.props.defaultMessage, this.props.chartHeader.key);

      return _react2.default.createElement(
        'div',
        { className: 'portfolio-child-card' },
        _react2.default.createElement(_reactWaypoint2.default, { topOffset: '35%', bottomOffset: '80%', onEnter: this.props.activeCardHandler.bind(this, this.props.id) }),
        _react2.default.createElement(
          _card_component2.default,
          {
            dataTest: this.props.id,
            headerTitle: this.props.chartHeader,
            headerTitleId: this.props.id,
            headerTitleLabel: this.props.headerTitlelabel ? this.props.headerTitlelabel : "portfolio-child-header",
            headerLabel: _date_formatter2.default.getEffectiveDateHeader(this.props.id, this.props.chartAsOfDate, this.props.country, this.props.role, this.props.breakpoint),
            disclosureText: this.props.disclosureText,
            breakpoint: this.props.breakpoint,
            placementId: this.props.placementId
          },
          _react2.default.createElement(
            'div',
            { 'data-testid': 'chartcontainer', className: 'padding-top-10' },
            this.props.children
          ),
          this.renderLegend(),
          !disableButton && _react2.default.createElement(_button2.default, {
            role: this.props.role,
            dataTest: "download-data",
            downloadURL: excelServiceURL,
            dataTestLink: this.props.id + '-excel-download',
            text: _string_utility2.default.renderFormattedLabel("DOWNLOAD CHART DATA", 'pdp-download-chart-data', { role: this.props.role }),
            additionalClassName: "mobile-full-width",
            callBack: function callBack() {
              return _this2.trackChartDownload(_this2.props.id);
            },
            ariaLabel: 'Download Chart Data for ' + headerTitle
          })
        )
      );
    }
  }]);

  return ChartContainer;
}(_react2.default.Component);

exports.default = ChartContainer;